import { ActionChipIcon } from '@/ActionChip/ActionChipIcon';
import { Icon as LegacyIcon } from '@zapier/design-system';
import { Icon } from '@zapier/zinnia-icons';
import { ReactElement, ReactNode, isValidElement } from 'react';

// eslint-disable-next-line @typescript-eslint/ban-types
const typeSet = new Set<string | Function>([
  'img',
  'svg',
  'picture',
  Icon,
  LegacyIcon,
  ActionChipIcon,
]);

// This function will _NOT_ work correctly if users have multiple versions of a
// library installed, since the functions will be created more than once. We
// could try to check `Function.prototype.name`, but minification might mangle
// the names, so that's not safe either. Ugh.
export function isIconElement(element: ReactNode): element is ReactElement {
  return isValidElement(element) && typeSet.has(element.type);
}
